import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { contentActionCreators } from "../../actions/contentActionCreators";
import { withStyles } from "@material-ui/core";
import EditArticleForm from "./forms/EditArticleForm";
import { getLoggedUser } from "../../helpers";
import { withTranslation } from "react-i18next"; // Import withTranslation

const styles = theme => ({});

class EditArticle extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleImageDrop = this.handleImageDrop.bind(this);

        //this.state = {
        //    language: 'bg' // or 'en'
        //};
        //this.handleLanguageChange = this.handleLanguageChange.bind(this);

    }
    //handleLanguageChange(e) {
    //    this.setState({ language: e.target.value });
    //}

    componentDidMount() {
        this.props.getArticle(this.props.match.params.id);
    }

    handleSubmit = e => {
        this.props.editArticle(this.props.articleToRead.imagesNames);
    };

    handleImageDrop = (e, filesToUpload) => {
        this.props.uploadImages(filesToUpload);
    };

    render() {
        const { t } = this.props; // Use t for translations
        const article = this.props.articleToRead;
        const user = getLoggedUser();
        const userId = user.id;

        return (
            <div>
                <h3>
                    {article.articleTypeId === 1
                        ? t('editNews') 
                        : t('editEvent')} 
                </h3>
                <EditArticleForm
                    getArticle={article}
                    initialValues={{
                        id: article.id,
                        articleTypeId: article.articleTypeId,
                        title: article.title,
                        titleEn: article.titleEn,
                        content: article.content,
                        contentEn: article.contentEn,
                        coverImg: article.coverImg,
                        eventDate: article.eventDate,
                        eventDateEnd: article.eventDateEnd,
                        eventLocation: article.eventLocation,
                        eventLocationEn: article.eventLocationEn,
                        createdOn: article.createdOn,
                        createdByUserId: article.createdByUserId,
                        timestamp: article.timestamp,
                        imagesFiles: article.imagesFiles
                    }}
                    onSubmit={this.handleSubmit}
                    onDrop={this.handleImageDrop}
                    userId={userId}

                    //language={this.state.language} // Pass the selected language
                />
            </div>
        );
    }
}

// Wrap the component with withTranslation HOC
export default withTranslation()(
    withStyles(styles)(
        connect(
            state => state.content,
            dispatch => bindActionCreators(contentActionCreators, dispatch)
        )(EditArticle)
    )
);

//import React, { Component } from "react";
//import { connect } from "react-redux";
//import { bindActionCreators } from "redux";
//import { contentActionCreators } from "../../actions/contentActionCreators";
//import { withStyles } from "@material-ui/core";
//import EditArticleForm from "./forms/EditArticleForm";
//import { getLoggedUser } from "../../helpers";

//const styles = theme => ({});

//class EditArticle extends Component {
//	constructor(props) {
//		super(props);

//		this.handleSubmit = this.handleSubmit.bind(this);
//		this.handleImageDrop = this.handleImageDrop.bind(this);
//	}

//	componentDidMount() {
//		this.props.getArticle(this.props.match.params.id);
//	}

//	handleSubmit = e => {
//		this.props.editArticle(this.props.articleToRead.imagesNames);
//	};

//	handleImageDrop = (e, filesToUpload) => {
//		this.props.uploadImages(filesToUpload);
//	};

//	render() {
//		const article = this.props.articleToRead;
//		const user = getLoggedUser();
//		const userId = user.id;

//		return (
//			<div>
//				<h3>
//					{article.articleTypeId === 1
//						? "Редактиране на новина"
//						: "Редактиране на събитие"}
//				</h3>
//				<EditArticleForm
//					getArticle={article}
//					initialValues={{
//						id: article.id,
//						articleTypeId: article.articleTypeId,
//						title: article.title,
//						content: article.content,
//						coverImg: article.coverImg,
//                        eventDate: article.eventDate,
//                        eventDateEnd: article.eventDateEnd,
//						eventLocation: article.eventLocation,
//						createdOn: article.createdOn,
//						createdByUserId: article.createdByUserId,
//						timestamp: article.timestamp,
//						imagesFiles: article.imagesFiles
//					}}
//					onSubmit={this.handleSubmit}
//                    onDrop={this.handleImageDrop}
//                    userId={userId}
//				/>
//			</div>
//		);
//	}
//}

//export default withStyles(styles)(
//	connect(
//		state => state.content,
//		dispatch => bindActionCreators(contentActionCreators, dispatch)
//	)(EditArticle)
//);
